module.exports = __webpack_public_path__ + "static/media/Library.b91950af.svg";